export default __webpack_public_path__ + "static/media/Nesha_Laser_0010_Laser_3.0101a28f.png";